require('./mixpanel-snippet');

var angular = require('angular');
var _module = angular.module('benoit');
var config = require('config');

require('angulartics');
require('angulartics-google-analytics');
require('../../../node_modules/angulartics-mixpanel/lib/angulartics-mixpanel');
require('./angulartics-console');

_module.requires.push('angulartics', 'angulartics.google.analytics', 'angulartics.console', 'angulartics.mixpanel');
